import React from "react";
import { useLocation } from "react-router-dom";
import CcDocumentComent from "./CcDocumentComent";

export default function CcDocumentComentWithKey() {
  const location = useLocation();

  return <CcDocumentComent key={location.key} />;
}
